"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FragmentsServiceFactory = void 0;
const fragments_loader_1 = require("./fragments-loader");
class FragmentsServiceFactory {
    static async initialize(options) {
        if (window.fragmentsLoader) {
            return;
        }
        if (!window.discoveryServiceUrl) {
            throw new Error('Configuration is missing (window.discoveryServiceUrl)');
        }
        window.fragmentsLoader = new fragments_loader_1.FragmentsLoader(window.discoveryServiceUrl, options);
        await window.fragmentsLoader.initialize();
    }
}
exports.FragmentsServiceFactory = FragmentsServiceFactory;
